<template>
  <v-app>
    <cv-header></cv-header>
    <v-main style="position:relative">
      <v-img :src="src" class="rec-login-bg" />
      <div class="login-wrap">
        <router-view> </router-view>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { getJson } from '@/api/network';

import CvHeader from '@/components/common/CvHeader';
export default {
  components: {
    CvHeader,
  },

  data: () => ({
    src: '',
    // height: window.innerHeight - 60 + 'px',
  }),
  mounted: function() {
    this.$store.commit('setTenant', this.$route.params.tenantKey);
    this.$nextTick(function() {
      this.setLoginBg();
    });
  },
  methods: {
    setLoginBg: function() {
      this.src = ''; //require(`@/img/login/bg_${this.$route.params.tenantKey}.png`);
      getJson('api/' + this.$route.params.tenantKey + '/image/login/bg', {})
        .then(res => {
          if (
            res &&
            res.data &&
            res.data.hasOwnProperty('image') &&
            res.data.image &&
            res.data.image != ''
          ) {
            this.src = res.data.image;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
.rec-login-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.login-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
